var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6005 0.399364C29.3449 0.143636 28.998 0 28.6364 0L1.36364 0.000363636C0.610545 0.000363636 0 0.610909 0 1.364V8.63636C0 9.38945 0.610545 10 1.36364 10H1.81818V28.6364C1.81818 29.3895 2.42873 30 3.18182 30H26.8182C27.5713 30 28.1818 29.3895 28.1818 28.6364V10H28.6364C29.3895 10 30 9.38945 30 8.63636V1.36364C30 1.00191 29.8564 0.655182 29.6005 0.399364ZM25.4545 27.2727H4.54545V10.0012L25.4545 10.0001V27.2727ZM27.2727 7.27273H2.72727V2.72764L27.2727 2.72727V7.27273Z",
    fill: "#BD6600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3636 15.4553H18.6364C19.3895 15.4553 20 14.8447 20 14.0916C20 13.3385 19.3895 12.728 18.6364 12.728H11.3636C10.6105 12.728 10 13.3385 10 14.0916C10 14.8447 10.6105 15.4553 11.3636 15.4553Z",
    fill: "#BD6600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.1521a427acb2bd66331f07d060220dfc.svg";
export { ForwardRef as ReactComponent };